// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* License Manager — Login */
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: #0b1220;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.login-background {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 60% at 10% 20%, rgba(59, 130, 246, 0.18) 0%, transparent 55%),
    radial-gradient(ellipse 70% 50% at 90% 80%, rgba(99, 102, 241, 0.14) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(14, 165, 233, 0.08) 0%, transparent 60%);
}

.login-background::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 100%);
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(11, 18, 32, 0.2) 0%, rgba(11, 18, 32, 0.6) 100%);
}

.login-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 920px;
  padding: 24px;
}

.login-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.06),
    0 24px 48px -12px rgba(0, 0, 0, 0.45),
    0 12px 24px -8px rgba(0, 0, 0, 0.25);
  animation: loginFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes loginFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Left brand panel */
.login-brand-panel {
  position: relative;
  padding: 48px 40px;
  background: linear-gradient(145deg, #1e3a8a 0%, #1d4ed8 45%, #2563eb 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 520px;
}

.login-brand-panel::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.12) 0%, transparent 45%),
    radial-gradient(circle at 80% 20%, rgba(147, 197, 253, 0.15) 0%, transparent 40%);
  pointer-events: none;
}

.login-brand-top {
  position: relative;
  z-index: 1;
}

.login-brand-logo {
  width: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}

.login-brand-logo svg {
  width: 26px;
  height: 26px;
  color: #fff;
}

.login-brand-panel h2 {
  font-size: 28px;
  font-weight: 800;
  margin: 0 0 12px;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.login-brand-panel p {
  font-size: 15px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.82);
  margin: 0;
}

.login-brand-features {
  position: relative;
  z-index: 1;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-brand-features li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.login-brand-features li svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #93c5fd;
}

/* Right form panel */
.login-form-panel {
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-header {
  margin-bottom: 32px;
}

.login-header h1 {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 6px;
  letter-spacing: -0.025em;
}

.login-subtitle {
  color: #64748b;
  font-size: 15px;
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 15px;
  font-weight: 600;
  color: #334155;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 14px;
  width: 18px;
  height: 18px;
  color: #94a3b8;
  z-index: 1;
  pointer-events: none;
}

.input-container input {
  width: 100%;
  padding: 13px 44px 13px 42px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  background: #f8fafc;
  color: #0f172a;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  outline: none;
  box-sizing: border-box;
}

.input-container input::placeholder {
  color: #94a3b8;
}

.input-container input:hover:not(:disabled) {
  border-color: #cbd5e1;
  background: #fff;
}

.input-container input:focus {
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.input-container input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

/* Kill browser autofill yellow */
.input-container input:-webkit-autofill,
.input-container input:-webkit-autofill:hover,
.input-container input:-webkit-autofill:focus {
  -webkit-text-fill-color: #0f172a;
  box-shadow: 0 0 0 1000px #f8fafc inset;
  border: 1.5px solid #e2e8f0;
  -webkit-transition: background-color 9999s ease-out;
  transition: background-color 9999s ease-out;
}

.input-container input:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #fff inset;
  border-color: #3b82f6;
}

.password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle:hover:not(:disabled) {
  background: #f1f5f9;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.password-toggle svg {
  width: 18px;
  height: 18px;
  color: #64748b;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  color: #b91c1c;
  font-size: 15px;
  font-weight: 500;
}

.error-message svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 24px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  margin-top: 4px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.login-button svg {
  width: 18px;
  height: 18px;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: loginSpin 0.8s linear infinite;
}

@keyframes loginSpin {
  to { transform: rotate(360deg); }
}

.login-footer {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
  text-align: center;
}

.login-footer p {
  color: #94a3b8;
  font-size: 15px;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .login-card {
    grid-template-columns: 1fr;
    max-width: 420px;
    margin: 0 auto;
  }

  .login-brand-panel {
    min-height: auto;
    padding: 32px 28px;
    gap: 24px;
  }

  .login-brand-panel h2 {
    font-size: 22px;
  }

  .login-brand-features {
    display: none;
  }

  .login-form-panel {
    padding: 32px 28px;
  }
}

@media (max-width: 480px) {
  .login-content {
    padding: 16px;
  }

  .login-form-panel {
    padding: 28px 22px;
  }

  .login-header h1 {
    font-size: 22px;
  }

  .input-container input {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;6FAG2F;AAC7F;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAC1B,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB;;;wCAGsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0EAA0E;EAC1E,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;qFAEmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iFAAiF;EACjF,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;;;EAGE,gCAAgC;EAEhC,sCAAsC;EACtC,2BAA2B;EAC3B,mDAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EAEE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2EAA2E;EAC3E,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* License Manager — Login */\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  background: #0b1220;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.login-background {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(ellipse 80% 60% at 10% 20%, rgba(59, 130, 246, 0.18) 0%, transparent 55%),\n    radial-gradient(ellipse 70% 50% at 90% 80%, rgba(99, 102, 241, 0.14) 0%, transparent 55%),\n    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(14, 165, 233, 0.08) 0%, transparent 60%);\n}\n\n.login-background::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);\n  background-size: 48px 48px;\n  mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 100%);\n}\n\n.login-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(11, 18, 32, 0.2) 0%, rgba(11, 18, 32, 0.6) 100%);\n}\n\n.login-content {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  max-width: 920px;\n  padding: 24px;\n}\n\n.login-card {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  background: #ffffff;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.06),\n    0 24px 48px -12px rgba(0, 0, 0, 0.45),\n    0 12px 24px -8px rgba(0, 0, 0, 0.25);\n  animation: loginFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes loginFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Left brand panel */\n.login-brand-panel {\n  position: relative;\n  padding: 48px 40px;\n  background: linear-gradient(145deg, #1e3a8a 0%, #1d4ed8 45%, #2563eb 100%);\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 520px;\n}\n\n.login-brand-panel::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.12) 0%, transparent 45%),\n    radial-gradient(circle at 80% 20%, rgba(147, 197, 253, 0.15) 0%, transparent 40%);\n  pointer-events: none;\n}\n\n.login-brand-top {\n  position: relative;\n  z-index: 1;\n}\n\n.login-brand-logo {\n  width: 52px;\n  height: 52px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 28px;\n}\n\n.login-brand-logo svg {\n  width: 26px;\n  height: 26px;\n  color: #fff;\n}\n\n.login-brand-panel h2 {\n  font-size: 28px;\n  font-weight: 800;\n  margin: 0 0 12px;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.login-brand-panel p {\n  font-size: 15px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.82);\n  margin: 0;\n}\n\n.login-brand-features {\n  position: relative;\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.login-brand-features li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.login-brand-features li svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: #93c5fd;\n}\n\n/* Right form panel */\n.login-form-panel {\n  padding: 48px 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.login-header {\n  margin-bottom: 32px;\n}\n\n.login-header h1 {\n  font-size: 24px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 6px;\n  letter-spacing: -0.025em;\n}\n\n.login-subtitle {\n  color: #64748b;\n  font-size: 15px;\n  margin: 0;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 14px;\n  width: 18px;\n  height: 18px;\n  color: #94a3b8;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.input-container input {\n  width: 100%;\n  padding: 13px 44px 13px 42px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 15px;\n  background: #f8fafc;\n  color: #0f172a;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input-container input::placeholder {\n  color: #94a3b8;\n}\n\n.input-container input:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background: #fff;\n}\n\n.input-container input:focus {\n  border-color: #3b82f6;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.input-container input:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n/* Kill browser autofill yellow */\n.input-container input:-webkit-autofill,\n.input-container input:-webkit-autofill:hover,\n.input-container input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #0f172a;\n  -webkit-box-shadow: 0 0 0 1000px #f8fafc inset;\n  box-shadow: 0 0 0 1000px #f8fafc inset;\n  border: 1.5px solid #e2e8f0;\n  transition: background-color 9999s ease-out;\n}\n\n.input-container input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #fff inset;\n  box-shadow: 0 0 0 1000px #fff inset;\n  border-color: #3b82f6;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  transition: background-color 0.15s ease;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.password-toggle:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.password-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.password-toggle svg {\n  width: 18px;\n  height: 18px;\n  color: #64748b;\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  color: #b91c1c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.error-message svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.login-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 24px;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n  margin-top: 4px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-button svg {\n  width: 18px;\n  height: 18px;\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: loginSpin 0.8s linear infinite;\n}\n\n@keyframes loginSpin {\n  to { transform: rotate(360deg); }\n}\n\n.login-footer {\n  margin-top: 28px;\n  padding-top: 20px;\n  border-top: 1px solid #f1f5f9;\n  text-align: center;\n}\n\n.login-footer p {\n  color: #94a3b8;\n  font-size: 15px;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .login-card {\n    grid-template-columns: 1fr;\n    max-width: 420px;\n    margin: 0 auto;\n  }\n\n  .login-brand-panel {\n    min-height: auto;\n    padding: 32px 28px;\n    gap: 24px;\n  }\n\n  .login-brand-panel h2 {\n    font-size: 22px;\n  }\n\n  .login-brand-features {\n    display: none;\n  }\n\n  .login-form-panel {\n    padding: 32px 28px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-content {\n    padding: 16px;\n  }\n\n  .login-form-panel {\n    padding: 28px 22px;\n  }\n\n  .login-header h1 {\n    font-size: 22px;\n  }\n\n  .input-container input {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
